var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6539_810)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 -7.62939e-05C12.4183 -7.62939e-05 16 3.58165 16 7.99992C16 12.4182 12.4183 15.9999 8 15.9999C3.58172 15.9999 0 12.4182 0 7.99992C0 3.58165 3.58172 -7.62939e-05 8 -7.62939e-05ZM14.488 8.87015C13.717 9.27118 12.7015 9.60652 11.5485 9.83773C11.3846 11.5118 10.997 12.9896 10.4331 14.0781C12.5851 13.2159 14.1726 11.2439 14.488 8.87015ZM10.1718 8.5851C10.1783 8.39244 10.1817 8.19724 10.1817 7.99984C10.1817 4.35183 9.02275 1.45438 7.99991 1.45438C6.97708 1.45438 5.81809 4.35183 5.81809 7.99984C5.81809 8.2086 5.82189 8.4149 5.82924 8.61834C6.51149 8.68967 7.24049 8.72728 7.99994 8.72728C8.7476 8.72728 9.48118 8.67454 10.1718 8.5851ZM11.6336 8.33026C11.6354 8.22067 11.6364 8.11054 11.6364 7.99992C11.6364 5.57979 11.1959 3.39426 10.433 1.92153C12.5975 2.78877 14.1911 4.77869 14.4934 7.17101C14.1512 7.55514 13.0717 8.01144 11.6336 8.33026ZM5.94823 10.0926C6.60067 10.1514 7.28785 10.1818 7.99994 10.1818C8.70052 10.1818 9.39078 10.1421 10.0546 10.0685C9.72657 12.6848 8.81953 14.5453 7.99991 14.5453C7.18282 14.5453 6.27883 12.6962 5.94823 10.0926ZM4.36768 8.40017C3.95023 8.3169 3.56117 8.21884 3.20594 8.10728C2.30375 7.82397 1.71418 7.47672 1.50219 7.20534C1.79352 4.79765 3.39205 2.79278 5.56703 1.92144C4.80408 3.39417 4.36364 5.57973 4.36364 7.99992C4.36364 8.13409 4.36499 8.26753 4.36768 8.40017ZM4.45756 9.8988C4.62486 11.5478 5.00994 13.0029 5.56691 14.0782C3.45219 13.2309 1.88244 11.3121 1.52937 8.9933C2.28827 9.38858 3.28968 9.6958 4.45756 9.8988Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6539_810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlobe);
export default __webpack_public_path__ + "static/media/ic-globe.825d333173f7574618b929afb02529cd.svg";
export { ForwardRef as ReactComponent };